import { Plus } from "neetoicons";
import { Dropdown } from "neetoui";

const AddDropdown = ({ addActions }) => (
  <Dropdown
    closeOnSelect
    position="bottom-end"
    customTarget={() => (
      <span
        className="neeto-molecules-sidebar__link-icon neeto-molecules-sidebar__link-icon--caret"
        data-testid="add-dropdown-trigger"
        onClick={e => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <Plus size={16} />
      </span>
    )}
  >
    <Dropdown.Menu>
      {addActions.map(action => (
        <Dropdown.MenuItem.Button
          key={action.key}
          onClick={e => {
            e.preventDefault();
            action.onClick?.(e);
          }}
        >
          {action.label}
        </Dropdown.MenuItem.Button>
      ))}
    </Dropdown.Menu>
  </Dropdown>
);

export default AddDropdown;
